module.exports = __webpack_public_path__ + "img/arrowL.327ee6fd.png";